var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirurgiaPlastica(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 511.972 511.972",
    height: 512,
    viewBox: "0 0 511.972 511.972",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m197 460.229h60v30h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m494.427 39.289c-23.394-23.394-61.459-23.394-84.853 0l-409.574 409.58 10.607 10.606c40.939 40.939 107.553 40.938 148.492-.001l86.828-86.83-10.606-10.606c-5.848-5.848-5.849-15.365 0-21.213l42.424-42.424 21.212 21.213 195.471-195.473c23.393-23.394 23.393-61.459-.001-84.852zm-280.32 280.323c-13.829 13.828-16.758 34.491-8.79 51.216l-67.432 67.434c-25.61 25.61-65.289 28.79-94.394 9.542l191.826-191.828 21.213 21.213zm84.849-42.424-42.426-42.426 21.214-21.214 42.425 42.427zm42.427-42.427-42.425-42.427 21.213-21.213 42.425 42.427zm131.831-131.832-89.405 89.406-42.425-42.427 89.403-89.405c11.697-11.697 30.729-11.697 42.427 0 11.697 11.696 11.697 30.728 0 42.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377 460.229h60v30h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287 460.229h60v30h-60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirurgiaPlastica);
export default __webpack_public_path__ + "static/media/cirurgia-plastica.bbbb8cbb95cea18f2ea6cf677be7b4b2.svg";
export { ForwardRef as ReactComponent };